(ns ycweb.components.versioncheck
  (:require
    [ycweb.util.comms :as comms]
    [ycweb.components.toaster :as toaster]
    [ycweb.components.history :as history]
    [util.transform :as trf]))

(defn version [app-atom]
  (get-in @app-atom [:app :version]))

(defn dev-enabled [app-atom]
  (= "dev" (version app-atom)))


(defmethod comms/receive :pos/version-check [app-atom e]
  (let [ver (version app-atom)
        screen (get-in @app-atom [:page :screen])]
    (when
      (and
        (not= "dev" ver)
        (> (trf/tonumber (:version e)) (trf/tonumber ver)))

      (if (#{:login :lock} screen)
        (do
          (swap! app-atom assoc-in [:page :screen] :disabled)
          ;; Try send a final history snapshot and refresh.
          #?(:cljs
             (history/send-snapshot history/app-snapshot
               (fn [] (.reload js/location)))))

        (toaster/open-toast app-atom :warning
          (str "Version is out of date, please refresh - New version: " (:version e))
          2500))))

  (swap! app-atom assoc-in [:version-check :server-version] (:version e)))


;; TODO: Test that the js/setTimeout works with anonymous function as one would expect... (passing app-state)
(defn check-version [app-atom]
  (when (get-in @app-atom [:version-check :started])
    (comms/send :pos/version-check
      {:current (version app-atom)
       :app (get-in @app-atom [:app :app])})

    #?(:cljs
        (js/setTimeout #(check-version app-atom) (* 5 60 1000)))))


(defn start-version-check [app-atom]
  (swap! app-atom assoc-in [:version-check :started] true)

  #?(:cljs (js/setTimeout #(check-version app-atom) 2000)))
